export function mapErrorToPensionEnrollmentKey(errorKey: string) {
    switch (errorKey) {
        case 'effective_date':
            return 'effective_date_year';
        case 'current_contribution.employee_contribution_percent':
        case 'current_contribution.employee_contribution_amount':
            return 'contribution_amount';
        default:
            return errorKey;
    }
}